import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.sub";
import "regenerator-runtime/runtime";
import router from '@/router/index';

var _import = require('@/libs/util.import.' + process.env.NODE_ENV);

import user from '@/store/modules/d2admin/modules/user';
import routes, { firstMenuPath } from './routes';
import setting from '@/setting';
import store from '@/store/index';
import { menuList } from '@/api/apis';
import layoutHeaderAside from '@/layout/header-aside';
import util from '@/libs/util';
var permissionMenu = [];

function importComponent(path) {
  try {
    return _import(path);
  } catch (e) {
    return null;
  }
}

function pushRoute(hotRoute) {
  var data = routes[0].children;
  var isExit = false;
  var toPath = hotRoute.action.substring(1, hotRoute.action.length);

  for (var i in data) {
    if (data[i].path === toPath) {
      isExit = true;
      break;
    }
  }

  if (!isExit) {
    var com = importComponent(hotRoute.controller + hotRoute.action);

    if (com === null) {
      return;
    }

    var routerItem = {
      path: hotRoute.action.substring(1, hotRoute.action.length),
      name: hotRoute.module,
      meta: {
        title: hotRoute.menu_name,
        auth: true,
        cache: true
      },
      component: com
    };
    routes[0].children.push(routerItem);
  }
}

function isRouter(obj) {
  if (!isMenu(obj)) {
    return false;
  }

  if (obj.sub && obj.sub.length > 0) {
    var hasMenu = false;

    for (var i in obj.sub) {
      if (obj.sub[i].is_show === 1) {
        hasMenu = true;
        break;
      }
    }

    if (hasMenu) {
      return false;
    }

    return true;
  }

  return true;
}

function isMenu(obj) {
  return obj.is_show;
}

function convertToMenuAndRoute(obj, aryMenu) {
  var userRules = user.state.info.rules_ids;

  if (userRules.indexOf(obj.id) < 0 && obj.id != 114 && obj.pid != 114) {
    //没有权限
    return;
  }

  if (!isMenu(obj)) {
    //不是菜单
    return;
  }

  var menu = {};
  menu.title = obj.menu_name;
  menu.path = obj.action;
  menu.icon = obj.icon;
  aryMenu.push(menu);

  if (isRouter(obj)) {
    //是路由
    pushRoute({
      controller: obj.controller,
      action: obj.action,
      module: obj.module,
      menu_name: obj.menu_name
    });
  } else {
    menu.children = [];

    for (var i in obj.sub) {
      convertToMenuAndRoute(obj.sub[i], menu.children);
    }
  }
}

function wait(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

export default {
  fetchPermissionInfo: function fetchPermissionInfo() {
    var res, i;
    return regeneratorRuntime.async(function fetchPermissionInfo$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            routes.unshift({
              path: '/',
              redirect: function redirect() {
                return firstMenuPath(store.state.d2admin.menu.aside) || '/login';
              },
              component: layoutHeaderAside,
              children: [// { path: 'setting/accountManager', name: '/setting/accountManager', meta: {title: '账户管理', auth: true }, component: _import('pages/setting/accountManager') },
              // { path: 'setting/menuManager', name: '/setting/menuManager', meta: {title: '菜单管理', auth: true }, component: _import('pages/setting/menuManager') },
              // { path: 'setting/roleManager', name: '/setting/roleManager', meta: {title: '角色管理', auth: true }, component: _import('pages/setting/roleManager') },
              {
                path: 'log',
                name: 'log',
                meta: {
                  title: '前端日志',
                  auth: true
                },
                component: _import('system/log')
              }, // 系统 前端日志
              {
                path: 'store/storeManager/index',
                name: 'storeManager',
                meta: {
                  title: '店铺管理',
                  auth: true,
                  cache: true
                },
                component: _import('pages/store/storeManager/index')
              }, // 店铺管理
              {
                path: 'finance/monthSend/index',
                name: 'monthSend',
                meta: {
                  title: '月结算发放',
                  auth: true,
                  cache: true
                },
                component: _import('pages/finance/monthSend/index')
              }, // 月结算手动发放
              {
                path: 'refresh',
                name: 'refresh',
                hidden: true,
                component: _import('system/function/refresh')
              }, // 刷新页面 必须保留
              {
                path: 'redirect/:route*',
                name: 'redirect',
                hidden: true,
                component: _import('system/function/redirect')
              } // 页面重定向 必须保留
              ]
            });
            _context.next = 3;
            return regeneratorRuntime.awrap(menuList({}));

          case 3:
            res = _context.sent;

            if (util.cookies.get('uuid') == 51) {
              setting.isDev = true;
            }

            for (i in res) {
              convertToMenuAndRoute(res[i], permissionMenu);
            }

            router.addRoutes(routes);
            store.commit('d2admin/menu/asideSet', permissionMenu);
            store.commit('d2admin/page/init', [routes[0]]); // 加载上次退出时的多页列表

            store.dispatch('d2admin/page/openedLoad');
            _context.next = 12;
            return regeneratorRuntime.awrap(Promise.resolve());

          case 12:
          case "end":
            return _context.stop();
        }
      }
    });
  }
};